import { render, staticRenderFns } from "./DestinationForm.vue?vue&type=template&id=3b464ea0"
import script from "./DestinationForm.vue?vue&type=script&lang=js"
export * from "./DestinationForm.vue?vue&type=script&lang=js"
import style0 from "./DestinationForm.vue?vue&type=style&index=0&id=3b464ea0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports